<script lang="ts">
    import type {SearchHistoryEntryDto} from 'typings/portaro.be.types';
    import {getDateFormatter, getInjector, getLocalization} from 'core/svelte-context/context';
    import {onMount} from 'svelte';
    import {KpSearchHistoryPanelPresenter} from './kp-search-history-panel.presenter';
    import {exists} from 'shared/utils/custom-utils';
    import {pipe} from 'core/utils';
    import {characters} from 'shared/utils/pipes';
    import KpGenericPanel from 'shared/ui-widgets/panel/KpGenericPanel.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import KpButtonStyleAnchor from 'shared/ui-widgets/button/KpButtonStyleAnchor.svelte';

    const localize = getLocalization();
    const dateFormatter = getDateFormatter();
    const presenter = getInjector().getByToken<KpSearchHistoryPanelPresenter>(KpSearchHistoryPanelPresenter.presenterName);

    let searchHistory: SearchHistoryEntryDto[];

    onMount(async () => {
        searchHistory = await presenter.getSearchHistory();
    });

    const handleFillToFormClick = (search: SearchHistoryEntryDto) => {
        presenter.dispatchFillToFormEvent(search);
    }
</script>

{#if exists(searchHistory) && searchHistory.length > 0}
    <section class="kp-search-history-panel visited-container" aria-labelledby="search-history-panel-label">
        <KpGenericPanel hasBodyPadding="{false}">
            <h2 id="search-history-panel-label" class="unset-style" slot="heading">
                <a href="/#!/search-history">
                    {localize(/* @kp-localization hledani.HistorieHledani */ 'hledani.HistorieHledani')}
                </a>
            </h2>

            <ul class="history-list list-group">
                {#each searchHistory as search}
                    <li class="history-item">
                        <div class="text-ellipsis">
                            <samp>{pipe(search.title, characters(300))}</samp>
                        </div>

                        <div class="controls">
                            <span>
                                {#if exists(search.qt)}
                                    <KpButton buttonStyle="link" buttonSize="md" on:click={() => handleFillToFormClick(search)}>
                                        {localize(/* @kp-localization hledani.FillToForm */ 'hledani.FillToForm')}
                                    </KpButton>
                                {/if}
                                <KpButtonStyleAnchor href="{search.url}" buttonStyle="link" buttonSize="md">
                                    {localize(/* @kp-localization commons.hledat */ 'commons.hledat')}
                                </KpButtonStyleAnchor>
                            </span>
                            <span class="text-muted small">
                                {pipe(search.date, dateFormatter('d.M.yyyy HH:mm'))}
                            </span>
                        </div>
                    </li>
                {/each}
            </ul>
        </KpGenericPanel>
    </section>
{/if}

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";
    @import (reference) "styles/portaro.variables.less";

    .history-list {
        margin: 0;

        .history-item {
            padding: @spacing-sm @spacing-ml;
            border-bottom: 1px solid @panel-default-border;

            &:last-child {
                border-bottom: none;
            }

            .controls {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                align-items: baseline;
            }
        }
    }
</style>